<div
  [attr.id]="helperId"
  class="be-input-helper"
  [ngClass]="{
    'be-input-helper--neutral': helperType === 'neutral',
    'be-input-helper--error': helperType === 'error'
  }"
  >
  <!-- alert triangle icon -->
  @if (helperType === 'error') {
    <svg
      viewBox="0 0 100 100"
      class="be-input-helper--icon be-input-helper--icon-error alert-triangle"
      >
      <use href="assets/icons-v2/sprites.svg#alert-triangle"></use>
    </svg>
  }

  <!-- check icon -->
  @if (helperType === 'success') {
    <svg
      viewBox="0 0 100 100"
      class="be-input-helper--icon check"
      >
      <use href="assets/icons-v2/sprites.svg#check-1"></use>
    </svg>
  }

  <ng-content></ng-content>
</div>
